import React, { useContext} from 'react'
import './Tabs.scss'
import { TabsContext } from '../../context/tabsContext'

const tabButtons = [
    {
        id: 1,
        name: 'Самый дешёвый',
        term: 'CHEAP'
    },
    {
        id: 2,
        name: 'Самый быстрый',
        term: 'FAST'
    }

]

const Tabs = () => {
    const {tab, setTab} = useContext(TabsContext)
    

    const tabItems = tabButtons.map(({ id, name, term }) => {
        const isActive = term === tab;
        const classNames = 'tabs__button ' + (isActive ? 'active' : null);
        return (
            <button key={id} className={classNames} type='button' onClick={() => setTab(term)}>{name}</button>
        )
    })

    return (
        <div className='tabs'>
            {tabItems}
        </div>
    )
}

export default Tabs
